import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTriangleTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconArrowTriangleTop"><Path d="M4.26615 16.3874C3.43667 18.0469 4.64288 20 6.49832 20H17.502C19.3574 20 20.5636 18.0469 19.7341 16.3874L14.2323 5.37998C13.3126 3.54001 10.6876 3.54001 9.76797 5.37998L4.26615 16.3874Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowTriangleTop;
